import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { GetPartCollectionApiParameter, GetWholegoodCollectionApiParameter } from "@store/Services/PartsService";
import { setBaseDataViewLoaded, setBaseDataViewLoading } from "@store/Store/Data/DataState";
import { PartsDataView, PartsState } from "@store/Store/Data/Parts/PartsState";
import { PartCollectionModel, WholegoodCollectionModel } from "@store/Types/Parts";
import { Draft } from "immer";

const initialState: PartsState = {
    dataViews: {},
    isLoading: {},
    byId: {},
};

let loadIndex = 0;
const reducer = {
    "Store/Data/Parts/BeginLoadParts": (
        draft: Draft<PartsState>,
        action: { parameter: GetPartCollectionApiParameter },
    ) => {
        setBaseDataViewLoading(draft, action.parameter);
    },
    "Store/Data/Parts/CompleteLoadParts": (
        draft: Draft<PartsState>,
        action: { parameter: GetPartCollectionApiParameter; collection: PartCollectionModel },
    ) => {
        const extraData = {
            parts: action.collection.parts.map(part => ({
                ...part,
                key: `${loadIndex++}`,
            })),
        } as PartsDataView;
        setBaseDataViewLoaded(draft, {type: "parts", ...action.parameter}, action.collection, extraData);
    },
    
    "Store/Data/Wholegoods/BeginLoadWholegoods": (
        draft: Draft<PartsState>,
        action: { parameter: GetWholegoodCollectionApiParameter },
    ) => {
        setBaseDataViewLoading(draft, action.parameter);
    },
    "Store/Data/Wholegoods/CompleteLoadWholegoods": (
        draft: Draft<PartsState>,
        action: { parameter: GetWholegoodCollectionApiParameter; collection: WholegoodCollectionModel },
    ) => {
        const extraData = {
            wholegoods: action.collection.products,
        } as PartsDataView;
        setBaseDataViewLoaded(draft, {type: "wholegoods", ...action.parameter}, action.collection, extraData);
    },
};

const partsReducer = createTypedReducerWithImmer(initialState, reducer);
export default partsReducer;
